import React, { useContext, useEffect, useState } from "react";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import DContext from "../../context/DContext";

import { DARK_LOGO_URL as darkLogo } from "../../config/siteConfig";
import toast from "react-hot-toast";
import { COMP_INFO, USER_ROLES } from "../../config/siteConfig";
import { BRAND_NAME } from "../../constants/brand";
import AuthBrandPanel from "../../components/auth/AuthBrandPanel";
import PasswordInput from "../../components/common/PasswordInput";
import { authenticationService } from "../../services/authentication.service";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { Alert } from "react-bootstrap";

import { useLoadingBar } from "react-top-loading-bar";

const ROLE_ICONS = {
  Admin: "bi-person-gear",
  Supplier: "bi-airplane",
  Partner: "bi-handshake",
};

const Login = () => {
  const { role } = useParams();
  const { start, complete } = useLoadingBar();

  const navigate = useNavigate();
  //const {redirecturl} = useParams();
  const [searchParams, setSearchParams] = useSearchParams();

  const { authState, authDispatch, login, logout } = useContext(DContext);
  const { user } = authState;

  const userRoles = USER_ROLES;

  const requestedRole = (role || searchParams.get("role") || "").toLowerCase();

  const [loginInfo, setLoginInfo] = useState({
    role_code: (
      userRoles.find((r) => r.role.toLowerCase() === requestedRole) ||
      userRoles.find((r) => r.isSelected)
    )?.role_code,
    username: "",
    password: "",
  });

  const [btnDisabled, setBtnDisabled] = useState(false);
  const [btnText, setBtnText] = useState("Login");
  const [loginErr, setLoginErr] = useState({
    message: null,
  });

  const showSwal = (title, text, icon) => {
    withReactContent(Swal).fire({
      title,
      text,
      icon, // 'success' | 'error' | 'warning' | 'info' | 'question'
    });
  };

  const handleChange = (e) => {
    setLoginInfo({ ...loginInfo, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      if (loginInfo?.username == "" || loginInfo?.password == "") {
        toast.error("Please Enter the Required Fields");
        return;
      }
      start();

      setBtnDisabled(true);
      setBtnText("Please Wait...");
      // const loginRes = await authenticationService.login({
      //     ...loginInfo,
      //     role_code: Number(loginInfo.role_code)
      // });
      //const { role_code, ...loginData } = loginInfo;
      const loginRes = await authenticationService.login(loginInfo);

      if (loginRes.success && loginRes.statusCode == 200) {
        toast.success("Hello " + loginRes?.resData?.user_info?.name);
        localStorage.setItem("token", loginRes.resData.token);
        const menuRes = await authenticationService.getMenuAccess(
          loginRes.resData.user_info.role_code,
        );
        authDispatch({ type: "LOGIN", payload: loginRes.resData.user_info });
        authDispatch({ type: "MENU_LOADED", payload: menuRes.resData });
        authDispatch({
          type: "USER_ROLE_LOADED",
          payload: loginRes.resData.user_info.role,
        });
        authDispatch({
          type: "PROFILE_LOADED",
          payload: loginRes.resData.user_profile_info,
        });
        authDispatch({ type: "WALLET_LOADED", payload: loginRes.resData.wallet_info });
        authDispatch({ type: "BANKS_LOADED", payload: loginRes.resData.bank_details });

        //redirectRoute();
      } else {
        setLoginErr({
          message: loginRes.response
            ? loginRes.response.data.message
            : loginRes.message,
        });
        //toast.error(loginRes.response ? loginRes.response.data.message : loginRes.message);
        setBtnDisabled(false);
        setBtnText("Login");
      }
    } catch (err) {
      showSwal("Error", "Something went wrong...", "error");
    } finally {
      complete();
    }
  };

  const redirectRoute = () => {
    let redirectUrl = searchParams.get("redirecturl");
    if (redirectUrl !== null) {
      console.log("redirect url found", redirectUrl);
      navigate(`/${redirectUrl}`);
    } else {
      navigate("/dashboard");
    }
  };

  useEffect(() => {}, []);

  return (
    <>
      <style>{`
        .login_mobile_brand { display: none; }
        @media (min-width: 768px) {
          .auth_login .auth_bg { height: auto; min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 32px 0; }
          .auth_login .auth_bg .auth_content { position: relative; inset: auto; margin: 0; height: auto; min-height: 70vh; }
          .auth_login .auth_bg .auth_content { align-items: stretch; }
          .auth_login .auth_bg .auth_content > .flex50 { display: flex; flex-direction: column; }
          .auth_login .auth_right { flex: 1 1 auto; height: auto !important; min-height: 100%; overflow: visible !important; }
        }
        @media (max-width: 767.98px) {
          .auth_login .auth_bg { height: 100dvh; }
          .auth_login .auth_bg .auth_content {
            width: 100%; height: 100%; border-radius: 0; box-shadow: none; background: transparent;
            flex-direction: column; overflow-y: auto; padding: 32px 16px;
          }
          .auth_login .auth_bg .auth_content .flex50 { max-width: 100%; flex: 0 0 auto; }
          .auth_login .auth_right {
            height: auto !important; overflow: visible !important; padding: 28px 22px !important;
            border-radius: 20px; box-shadow: 0 20px 60px rgba(14,106,150,0.15);
            max-width: 440px; margin: 0 auto;
          }
          .auth_login .login_mobile_brand {
            display: flex; flex-direction: column; align-items: center; text-align: center;
            width: 100%; margin-bottom: 20px; padding-bottom: 16px; border-bottom: 1px solid #eef0f8;
          }
          .auth_login .login_mobile_brand a { display: inline-flex; align-items: center; gap: 10px; text-decoration: none; }
          .auth_login .login_mobile_brand img { height: 36px; width: auto; object-fit: contain; }
          .auth_login .login_mobile_name { display: block; font-size: 18px; font-weight: 700; line-height: 1.1; color: #0f172a; text-align: left; }
          .auth_login .login_mobile_sub { display: block; font-size: 12px; color: #64748b; margin-top: 2px; text-align: left; }
          .auth_login .auth_right form input { font-size: 16px !important; }
        }
      `}</style>
      <div className="auth_login">
        <div className="auth_bg">
          <div className="auth_content">
            {/* Left panel — hidden on mobile */}
            <div className="flex50 d-none d-md-flex">
              <AuthBrandPanel
                ctaText="Want to become a supplier?"
                ctaLabel="Register now"
                ctaTo="/signup"
              />
            </div>

            {/* Right panel — full width on mobile */}
            <div className="flex50" style={{ flex: "1 1 auto", minWidth: 0 }}>
              <div
                className="auth_right"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  overflowY: "auto",
                  padding: "32px 20px",
                  background: "rgba(255,255,255,0.95)",
                  backdropFilter: "blur(24px)",
                }}
              >
                <div style={{ width: "100%", maxWidth: "400px" }}>
                  {/* Mobile-only: brand header (dark logo on white card) */}
                  <div className="login_mobile_brand d-md-none">
                    <Link to="/" aria-label={`${BRAND_NAME} home`}>
                      <img src={darkLogo} alt="" />
                      <span>
                        <span className="login_mobile_name">{BRAND_NAME}</span>
                        <span className="login_mobile_sub">
                          {COMP_INFO.NAME}
                        </span>
                      </span>
                    </Link>
                  </div>

                  {/* Page header */}
                  <div style={{ marginBottom: "24px", textAlign: "center" }}>
                    <h4
                      style={{
                        fontWeight: "700",
                        color: "#0f172a",
                        fontSize: "22px",
                        marginBottom: "4px",
                      }}
                    >
                      Sign In
                    </h4>
                    <p
                      style={{ color: "#64748b", fontSize: "13px", margin: 0 }}
                    >
                      Access your account to manage flight inventory & billing.
                    </p>
                  </div>

                  {/* Role Selector */}
                  <div
                    style={{
                      display: "flex",
                      gap: "6px",
                      padding: "4px",
                      marginBottom: "28px",
                      background: "#f1f5f9",
                      border: "1px solid rgb(15 118 110)",
                      borderRadius: "16px",
                    }}
                  >
                    {userRoles.map((roleType) => {
                      const isSelected =
                        loginInfo.role_code == roleType.role_code;
                      return (
                        <button
                          type="button"
                          key={roleType.role_code}
                          onClick={() =>
                            setLoginInfo({
                              ...loginInfo,
                              role_code: roleType.role_code,
                            })
                          }
                          style={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "8px",
                            padding: "11px 8px",
                            border: "none",
                            borderRadius: "12px",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: isSelected ? "600" : "500",
                            color: isSelected ? "#0f172a" : "#64748b",
                            background: isSelected
                              ? "var(--btn-bg)"
                              : "transparent",
                            boxShadow: isSelected
                              ? "0 2px 8px rgba(15,23,42,0.08)"
                              : "none",
                            transition: "all 0.15s",
                          }}
                        >
                          <i
                            className={`bi ${ROLE_ICONS[roleType.role] || "bi-person"}`}
                            style={{ color: isSelected ? "#fff" : "#94a3b8" }}
                          ></i>
                          {roleType.role}
                        </button>
                      );
                    })}
                  </div>

                  <form onSubmit={handleSubmit}>
                    {/* Error */}
                    {loginErr?.message && (
                      <div
                        style={{
                          background: "#fff4f4",
                          border: "1.5px solid #fecaca",
                          borderRadius: "10px",
                          padding: "10px 14px",
                          color: "#c45252",
                          fontSize: "13px",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          marginBottom: "20px",
                        }}
                      >
                        <i
                          className="bi bi-exclamation-circle-fill"
                          style={{ flexShrink: 0 }}
                        ></i>
                        {loginErr.message}
                      </div>
                    )}

                    {/* Username */}
                    <div style={{ marginBottom: "14px" }}>
                      <label
                        style={{
                          fontSize: "11px",
                          fontWeight: "700",
                          color: "#64748b",
                          textTransform: "uppercase",
                          letterSpacing: "0.8px",
                          display: "block",
                          marginBottom: "8px",
                        }}
                      >
                        User Id
                      </label>
                      <div style={{ position: "relative" }}>
                        <i
                          className="bi bi-person"
                          style={{
                            position: "absolute",
                            left: "14px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#c0cad8",
                            fontSize: "14px",
                          }}
                        ></i>
                        <input
                          type="text"
                          name="username"
                          id="username"
                          placeholder="Enter your mobile number"
                          autoComplete="off"
                          onChange={handleChange}
                          style={{
                            width: "100%",
                            padding: "12px 14px 12px 40px",
                            border: "1.5px solid #dfe3ec",
                            borderRadius: "10px",
                            fontSize: "13px",
                            color: "#0f172a",
                            background: "#f8fafc",
                            outline: "none",
                            transition: "border-color 0.15s, box-shadow 0.15s",
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "var(--btn-bg)";
                            e.target.style.boxShadow =
                              "0 0 0 3px rgba(14,106,150,0.15)";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#dfe3ec";
                            e.target.style.boxShadow = "none";
                          }}
                        />
                      </div>
                    </div>

                    {/* Password */}
                    <div style={{ marginBottom: "15px" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      >
                        <label
                          style={{
                            fontSize: "11px",
                            fontWeight: "700",
                            color: "#64748b",
                            textTransform: "uppercase",
                            letterSpacing: "0.8px",
                            margin: 0,
                            width: "auto",
                            flex: "0 0 auto",
                          }}
                        >
                          Password
                        </label>
                        <Link
                          to="/forgot-password"
                          style={{
                            marginLeft: "auto",
                            whiteSpace: "nowrap",
                            textDecoration: "none",
                            fontSize: "12px",
                            color: "rgb(15 118 110)",
                            fontWeight: "600",
                          }}
                        >
                          Forgot password?
                        </Link>
                      </div>
                      <div style={{ position: "relative" }}>
                        <i
                          className="bi bi-key"
                          style={{
                            position: "absolute",
                            zIndex: 1,
                            pointerEvents: "none",
                            left: "14px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            color: "#c0cad8",
                            fontSize: "14px",
                          }}
                        ></i>
                        <PasswordInput
                          name="password"
                          id="password"
                          placeholder="Enter your password"
                          autoComplete="off"
                          onChange={handleChange}
                          style={{
                            width: "100%",
                            padding: "12px 14px 12px 40px",
                            border: "1.5px solid #dfe3ec",
                            borderRadius: "10px",
                            fontSize: "13px",
                            color: "#0f172a",
                            background: "#f8fafc",
                            outline: "none",
                            transition: "border-color 0.15s, box-shadow 0.15s",
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "var(--btn-bg)";
                            e.target.style.boxShadow =
                              "0 0 0 3px rgba(14,106,150,0.15)";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#dfe3ec";
                            e.target.style.boxShadow = "none";
                          }}
                        />
                      </div>
                    </div>

                    {/* OTP badge */}
                    <div style={{ textAlign: "right", marginBottom: "20px" }}>
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                          padding: "6px 12px",
                          borderRadius: "8px",
                          background: "#eef2ff",
                          color: "#4f46e5",
                          fontSize: "12px",
                          fontWeight: "600",
                        }}
                      >
                        {/* <i className="bi bi-shield-fill-check"></i>
                        OTP Protected */}
                      </span>
                    </div>

                    {/* Submit */}
                    <button
                      type="submit"
                      disabled={btnDisabled}
                      style={{
                        width: "100%",
                        padding: "13px",
                        background: btnDisabled ? "#9cc7c2" : "var(--btn-bg)",
                        color: "white",
                        border: "none",
                        borderRadius: "12px",
                        fontSize: "14px",
                        fontWeight: "700",
                        letterSpacing: "0.3px",
                        cursor: btnDisabled ? "not-allowed" : "pointer",
                        transition: "all 0.2s",
                        boxShadow: btnDisabled
                          ? "none"
                          : "0 4px 14px rgba(14,106,150,0.25)",
                      }}
                      onMouseEnter={(e) => {
                        if (!btnDisabled) {
                          e.currentTarget.style.transform = "translateY(-1px)";
                          e.currentTarget.style.boxShadow =
                            "0 6px 20px rgba(14,106,150,0.32)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "";
                        e.currentTarget.style.boxShadow = btnDisabled
                          ? "none"
                          : "0 4px 14px rgba(14,106,150,0.25)";
                      }}
                    >
                      <i
                        className={`bi ${btnDisabled ? "bi-hourglass-split" : "bi-box-arrow-in-right"} me-2`}
                      ></i>
                      {btnText}
                    </button>

                    {/* API documentation link */}
                    <div className="text-center mt-3">
                      <a
                        href="https://api-supplier.virtualtoactual.cloud/service-api-documentation"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          textDecoration: "none",
                          fontSize: "12px",
                          color: "rgb(14, 106, 150)",
                          fontWeight: "600",
                        }}
                      >
                        <i className="bi bi-code-slash me-1"></i>
                        We are offering API — View API Documentation
                      </a>
                    </div>

                    {/* Mobile: register link */}
                    <div className="d-flex d-md-none justify-content-center mt-4">
                      <span style={{ fontSize: "12px", color: "#64748b" }}>
                        New supplier?&nbsp;
                      </span>
                      <Link to="/signup" style={{ textDecoration: "none" }}>
                        <span
                          style={{
                            fontSize: "12px",
                            color: "var(--btn-bg)",
                            fontWeight: "700",
                          }}
                        >
                          Register Now
                        </span>
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
